"use strict";
/* eslint-disable import/prefer-default-export */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSkillTrees = exports.mockUserSkillTree = exports.mockUserSkillTreeLearningPath = void 0;
exports.mockUserSkillTreeLearningPath = {
    id: 4,
    uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc4',
    name: 'Security Champion',
    description: 'Rimzibtep moses lu atacerev bufaid degwe efe ivpe ci mic zacad esajud judsis boluw duupufol.',
    level: 'basic',
    duration: 80,
    potentialScore: 13000,
    score: 5000,
    status: null,
    languages: ['java', 'php', 'c++', '.net'],
    nodes: [
        {
            id: 531,
            uuid: 'dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
            name: 'Lessons 2',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 345,
                    uuid: '6167f2448df887298f76a622',
                    displayName: 'Horizontal Privilege Escalation',
                    url: '/courses/java_advanced_lessons2/lessons/horizontal_privilege_escalation?learningPathNodeUuid=dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
                    status: 'not_started',
                    type: 'lesson',
                },
                {
                    id: 346,
                    uuid: '6167f2478df887cab476a62b',
                    displayName: 'XXE Processing',
                    url: '/courses/java_advanced_lessons2/lessons/xxe_processing?learningPathNodeUuid=dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [534],
            parents: [],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 532,
            uuid: 'd5af23aa-5454-49c0-b0fe-040a15de0301',
            name: 'Lessons 1',
            potentialScore: 2000,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 343,
                    uuid: '6167f2262479f1d7bcd5578f',
                    displayName: 'Broken Function-Level Authorization',
                    url: '/courses/dotnet_api_security/lessons/broken_function_level_authorization?learningPathNodeUuid=d5af23aa-5454-49c0-b0fe-040a15de0301',
                    status: 'not_started',
                    type: 'lesson',
                },
                {
                    id: 344,
                    uuid: '6167f226c27d3d66819529b5',
                    displayName: 'Brute Force Attacks ',
                    url: '/courses/dotnet_api_security/lessons/brute_force_attacks_overview?learningPathNodeUuid=d5af23aa-5454-49c0-b0fe-040a15de0301',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [535, 534],
            parents: [],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 533,
            uuid: '8a8f7729-eb8f-4ddd-8d81-fad9aed83e54',
            name: 'Lessons 5',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 349,
                    uuid: '6167f2458df887703576a625',
                    displayName: 'LDAP injection',
                    url: '/courses/java_advanced_lessons2/lessons/ldap_injection?learningPathNodeUuid=8a8f7729-eb8f-4ddd-8d81-fad9aed83e54',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [],
            parents: [534],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 534,
            uuid: 'abdfe8ce-7082-4e29-8af5-76f9c65556aa',
            name: 'Lessons 3',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 347,
                    uuid: '6167f244c27d3d9955952a13',
                    displayName: 'Insecure Object Deserialization',
                    url: '/courses/java_advanced_lessons2/lessons/insecure_object_deserialization?learningPathNodeUuid=abdfe8ce-7082-4e29-8af5-76f9c65556aa',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [533],
            parents: [531, 532],
            progressPercentage: 0,
            isMandatory: false,
        },
        {
            id: 535,
            uuid: 'f777fc63-eb9d-4da5-87e7-e915df2f9241',
            name: 'Lessons 4',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 348,
                    uuid: '6167f2442479f106acd557f5',
                    displayName: 'Insecure Password Storage',
                    url: '/courses/java_advanced_lessons2/lessons/insecure_password_storage?learningPathNodeUuid=f777fc63-eb9d-4da5-87e7-e915df2f9241',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [],
            parents: [532],
            progressPercentage: 0,
            isMandatory: true,
        },
    ],
};
exports.mockUserSkillTree = {
    uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc4',
    name: 'Security Champion',
    duration: 80,
    progress: 100,
    points: 5000,
    status: 'completed',
    completedAt: '2023-06-24T12:45:21.476Z',
    languages: ['java', 'php', 'c++', '.net'],
    learningPaths: [
        {
            uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc4',
            name: 'Security Champion',
            numberOfItems: 5,
        },
        {
            uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc42',
            name: 'skill tree 1',
            numberOfItems: 8,
        },
        {
            uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc44',
            name: 'skill tree 2',
            numberOfItems: 10,
        },
        {
            uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc477',
            name: 'skill tree 3',
            numberOfItems: 5,
        },
    ],
    selectedLearningPath: exports.mockUserSkillTreeLearningPath,
};
exports.mockSkillTrees = [
    {
        uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc477',
        name: 'CB Champion',
        description: 'Do you want to become a CB Champion?',
        duration: 500,
        level: 'advanced',
        progress: null,
        score: 1000,
    },
    {
        uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc44',
        name: 'AppSec Expert',
        description: 'Best opportunity to become an AppSec Expert',
        duration: 200,
        level: 'expert',
        progress: {
            status: 'started',
            percent: 20,
            points: 5000,
            startedAt: '2023-08-30T12:09:26.000Z',
            completedAt: null,
        },
    },
];
